/**
 * The AFF simulator's status and admin requests (#866), GET/POST /api/aff/sim.
 *
 * EasyMap asks, the collector acts: a POST only records a request, which the
 * AFF collector carries out on its next run.
 */
import { getBackendUrl } from './configService';

export type AffSimAction = 'start' | 'stop' | 'clear';

export interface AffSimStatus {
  /** This server's environment: local, staging, uat or production. */
  environment: string | null;
  /** When the running session started; null when none runs. */
  startedAt: string | null;
  /** Simulated aircraft on the live layer. */
  simPositions: number;
  /** The action the collector has not handled yet, if any. */
  pending: AffSimAction | null;
}

const ENV_LABELS: Record<string, string> = { local: 'Local', staging: 'Staging', uat: 'UAT', production: 'Production' };

export const affSimEnvLabel = (target: string | null): string => ENV_LABELS[target ?? ''] ?? 'an unknown environment';

export async function fetchAffSimStatus(): Promise<AffSimStatus> {
  const response = await fetch(`${getBackendUrl()}/api/aff/sim/status`, { credentials: 'include' });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
}

/** Record a request. No target is sent: the server uses its own environment. */
export async function requestAffSim(action: AffSimAction): Promise<void> {
  const response = await fetch(`${getBackendUrl()}/api/aff/sim/${action}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: '{}',
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body?.message || `HTTP ${response.status}`);
  }
}
